import { lookLayers, pinLayers, type LayeredLook } from "../peon-art.ts";

/**
 * What a peon wears over their portrait (docs/peon-look.md; owner, 2026-10-04: "Make peon hairstyles
 * and accessories that are purchasable with gold"): the beard, the hair, then the accessories neck,
 * ears, face (shared/cosmetics.ts DRAW_ORDER), each a transparent 46x44 layer at the portrait's
 * pixel scale. Over the crowned portrait a layer covers the box exactly. Over the 46x38 mascot, who
 * sits on the bottom of a 46x44-shaped box, it starts 4 art pixels above his top and hangs 2 empty
 * rows below his bottom (`.peon-layer-plain`), so he does not move. The parent is the positioned box
 * (`.self-portrait`, `.wardrobe-tile-art`, or `.peon-stack` around a crowned portrait). Nothing for a
 * part that is "none", never chosen, or a value this build does not know.
 *
 * After the accessories, the badge worn (owner, 2026-10-05: "Rather than 3 badges should just be able to set one
 * badge that sits on the peons shirt where the existing emblem is"): one 8x8 pin over the shirt's stitched patch (`.peon-pin`,
 * src/peon-art.ts pinLayers), its cell of public/ui/badge-pins.png. The small peon and the stamp (SmallPeon) draw lookLayers only: no pins.
 */
export function PeonLayers({ look, crowned }: { look: LayeredLook; crowned: boolean }) {
  const layers = lookLayers(look, crowned);
  const pins = pinLayers(look, crowned);
  if (layers.length === 0 && pins.length === 0) return null;
  return (
    <>
      {layers.map((l) => (
        <img key={l.key} class={crowned ? "peon-layer" : "peon-layer peon-layer-plain"} data-layer={l.key} src={l.src} alt="" aria-hidden="true" />
      ))}
      {pins.map((p) => (
        <span
          key={`pin-${p.key}`}
          class="peon-pin"
          data-pin={p.key}
          aria-hidden="true"
          style={{ left: p.left, top: p.top, width: p.width, height: p.height, backgroundSize: p.backgroundSize, backgroundPosition: p.backgroundPosition }}
        />
      ))}
    </>
  );
}
